var map = {
	"./en.svg": 3931,
	"./facebook.svg": 1378,
	"./icons8-telegram-app.svg": 4450,
	"./icons8-telegram.svg": 8204,
	"./instagram.svg": 6166,
	"./linkedin.svg": 3816,
	"./mail.svg": 683,
	"./phone.svg": 9070,
	"./ru.svg": 9437,
	"./uk.svg": 2854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;